var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mingcute:add-fill",
    clipPath: "url(#clip0_663_1024)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M35.0007 66.6667C35.0007 67.9928 35.5274 69.2646 36.4651 70.2022C37.4028 71.1399 38.6746 71.6667 40.0007 71.6667C41.3267 71.6667 42.5985 71.1399 43.5362 70.2022C44.4739 69.2646 45.0006 67.9928 45.0006 66.6667V45H66.6673C67.9934 45 69.2652 44.4733 70.2028 43.5356C71.1405 42.5979 71.6673 41.3261 71.6673 40C71.6673 38.674 71.1405 37.4022 70.2028 36.4645C69.2652 35.5268 67.9934 35 66.6673 35H45.0006V13.3334C45.0006 12.0073 44.4739 10.7355 43.5362 9.79784C42.5985 8.86016 41.3267 8.33337 40.0007 8.33337C38.6746 8.33337 37.4028 8.86016 36.4651 9.79784C35.5274 10.7355 35.0007 12.0073 35.0007 13.3334V35H13.334C12.0079 35 10.7361 35.5268 9.79845 36.4645C8.86077 37.4022 8.33398 38.674 8.33398 40C8.33398 41.3261 8.86077 42.5979 9.79845 43.5356C10.7361 44.4733 12.0079 45 13.334 45H35.0007V66.6667Z",
    fill: "#7DF08E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_663_1024"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.b7cdaa74a03b5c2a8adf29682e35844e.svg";
export { ForwardRef as ReactComponent };